import mergeBlockImageMap from '../../assets/mergeBlockImageMap.json';

export const useMergeBlockImageMap = () => {
    return {data: mergeBlockImageMap};
};

export const resolveMergeBlockImageUrl = (resourcePath, imageMap) => {
    if (!resourcePath) return '';
    const stem = resourcePath.includes('/') ? resourcePath.split('/').pop() : resourcePath;
    const resolved = imageMap?.[stem] ?? imageMap?.[resourcePath];
    if (resolved) return `/UI/Images/${resolved}`;
    return `/UI/Images/Merge/MergeBlock/${resourcePath}.png`;
};
